import { createIcon } from "@chakra-ui/react";

const ChevronDownLine = createIcon({
  displayName: "ChevronDownLine",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clip-rule="evenodd"
      d="M2.35984 4.23177C2.78412 3.87821 3.41468 3.93553 3.76825 4.35981L8.00003 9.43794L12.2318 4.35981C12.5854 3.93553 13.2159 3.87821 13.6402 4.23177C14.0645 4.58534 14.1218 5.2159 13.7682 5.64018L8.76825 11.6402C8.57825 11.8682 8.29681 12 8.00003 12C7.70325 12 7.4218 11.8682 7.2318 11.6402L2.2318 5.64018C1.87824 5.2159 1.93556 4.58534 2.35984 4.23177Z"
      fill="currentColor"
    />
  )
});

export default ChevronDownLine;
